<template>
    <div>
        <v-dialog ref="userSearchDialog" v-model="localDialog" hide-overlay persistent max-width="400px">
            <v-card :loading="loading ? 'primary' : false" elevation="4" outlined>
                <v-card-title>
                    {{ $t("login.TitleUserModal") }}
                </v-card-title>

                <v-card-text>
                    <div class="d-flex flex-column align-center">
                        <span class="mt-3">
                            {{ $t("login.TitleSearchLabel") }}
                        </span>
                        <span class="mt-3">
                            {{ $t("login.TitleSearchMax10Label") }}
                        </span>
                    </div>
                </v-card-text>


                <div class="mx-5">
                    <v-autocomplete
                        ref="clientAutocomplete"
                        v-model="selectedClient"
                        :items="filteredUserList"
                        :loading="loading"
                        :search-input.sync="search"
                        item-text="label"
                        item-value="clientId"
                        clearable
                        color="primary"
                        :filter="() => true"
                        @input="onInput"
                    >
                        <template #no-data>
                            <div v-if="!loading" class="px-4 py-2">
                                {{ (!search || search.length < 3) || loading ? $t('login.TitleSearchLabel') : 'NOT FOUND' }}
                            </div>
                        </template>
                        <template #item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-content>
                                    <div class="d-flex">
                                        <span class="v-list-item__title" v-html="item.label"></span>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>

                </div>

                <v-divider></v-divider>

                <v-card-actions class="d-flex align-center">
                    <v-checkbox
                        v-model="showAllClient"
                        class="mt-0"
                        label="Buscar entre todos los clientes"
                        color="primary"
                        hide-details
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-btn  :loading="loading" :disabled="loading || !selectedClient" color="primary" @click="loginSelectedClient">
                        {{ $t("login.InitUserModal") }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';


export default {
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedClient: null,
            // selectedUser: null,
            loading: false,
            search: '',
            showAllClient: false,
            debouncedSearch: null,
            lastSearchEmpty: false
        };
    },
    computed: {
        ...mapGetters('config', ['userList']),
        filteredUserList() {
            return this.lastSearchEmpty ? [] : this.userList;
        }
    },
    watch: {
        dialog(newVal) {
            if (newVal != this.localDialog) this.localDialog = newVal;

            if (newVal) {
                 this.lastSearchEmpty = false;
                 this.clearUserList();
                 this.$nextTick(() => { this.$refs.userSearchDialog.showScroll(); });
            }
        },
        localDialog(newVal) {
            if (newVal != this.dialog) {
                this.cerrar();
            }
        },
        showAllClient() {
            if (this.search && this.search.length >= 3) {
                this.executeSearch(false); // Búsqueda inmediata al cambiar el filtro
            }
        },
        search(val) {
            if (!val || val.length === 0) {
                 this.lastSearchEmpty = false;
                 this.clearUserList();
                 return;
            }
            if (val.length < 3) return;
            
            // Si el valor cambia, asumimos que va a haber resultados hasta que la API diga lo contrario
            this.lastSearchEmpty = false;
            
            // Si el texto coincide con el label del cliente seleccionado, no buscamos (es el usuario seleccionando)
            const selectedItem = this.userList?.find(u => u.clientId === this.selectedClient);
            if (selectedItem && selectedItem.label === val) return;

            // Activamos loading inmediatamente para feedback visual y ocultar "no-data"
            this.loading = true;
            this.debouncedSearch();
        }
    },
    created() {
        // Inicializamos el debounce aquí para que sea único por instancia
        this.debouncedSearch = debounce(() => {
            this.executeSearch(true);
        }, 500);
    },
    methods: {
        ...mapActions('config', ['searchUserList', 'loginClient', 'key', 'clearUserList']),
        cerrar: function () {
            this.localDialog = false;
            this.search = '';
            this.selectedClient = null;
            this.clearUserList();
            this.$emit("cerrar");
        },
        async loginSelectedClient() {
            this.loading = true;
            try {
                await this.loginClient({
                    clientId: this.selectedClient
                });
            } finally {
                this.loading = false;
                this.cerrar();
            }
        },
        async executeSearch(fromDebounce = false) {
            // Protección doble: si no venimos de debounce (ej. click checkbox), ponemos loading
            if (!fromDebounce) this.loading = true;

            try {
                const data = await this.searchUserList({
                    search: this.search,
                    showAllClient: this.showAllClient
                });

                if (data && data.listClient) {
                    this.lastSearchEmpty = data.listClient.length === 0;

                    // Auto-seleccionar si solo hay 1 resultado en el REQUEST ACTUAL
                    if (data.listClient.length === 1) {
                        this.selectedClient = data.listClient[0].clientId;
                        // Al autoseleccionar, también limpiamos estado de carga para permitir acción inmediata
                        this.onInput();
                    }

                    // Hacer scroll al principio de la lista para mostrar los nuevos resultados
                    this.$nextTick(() => {
                        const menu = this.$refs.clientAutocomplete?.$refs?.menu;
                        if (menu && menu.$refs?.content) {
                            menu.$refs.content.scrollTop = 0;
                        }
                    });
                } else {
                    this.lastSearchEmpty = true;
                }
            } finally {
                this.loading = false;
            }
        },
        onInput() {
            if (this.selectedClient) {
                // Al seleccionar un cliente, cancelamos cualquier búsqueda pendiente y quitamos loading
                if (this.debouncedSearch) this.debouncedSearch.cancel();
                this.loading = false;
            }
        },
    }
};

</script>
